import { createContext } from 'react';
import { NotificationInstance } from 'antd/es/notification/interface';

export const AppContext = createContext<
  { apiNotification: NotificationInstance } | undefined
>(undefined);
